export default __webpack_public_path__ + "static/media/vehicle-placeholder.b7e6c349.jpg";